import { Injectable, TemplateRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class DialogService {
  constructor(private dialog: MatDialog) {}

  openDialog(template: TemplateRef<any>): Observable<any> {
    return this.dialog.open(template).afterClosed();
  }

  closeAll(): void {
    this.dialog.closeAll();
  }
}
